<template>
  <CRow>
    <CCol col="12">
      <CCard>
        <CCardHeader>
          <CRow>
            <CCol sm="7">
              <h4 id="traffic" class="card-title mb-0">Podcast List</h4>
            </CCol>
          </CRow>
        </CCardHeader>
        <CCardBody>
          <CRow class="mb-1 d-flex justify-content-between">
            <CCol col="2">
              <CButton
                color="primary"
                class="float-left mb-2"
                @click="corporatePodcastCreate"
              >
                Create
              </CButton>
            </CCol>
            <!-- Search -->
            <CCol class="float-right" col="3">
              <div class="search-list">
                <CInput
                  placeholder="Search By Podcast Title"
                  v-model="request.q"
                  @input="onSearch()"
                >
                  <template #prepend-content>
                    <CIcon name="cil-magnifying-glass" />
                  </template>
                </CInput>
              </div>
            </CCol>
          </CRow>
          <CDataTable
              hover
              striped
              :items="items"
              :fields="fields"
              :items-per-page="100"
              clickable-rows
              :active-page="1"
              :pagination="false"
              @page-change="pageChange"
          >
            <template #corporate_podcast_ids="data">
              <td>
                <div class="button-table">
                  <CButton
                      color="primary"
                      class="mb-0 mr-0"
                      @click="rowClicked(data.item.corporate_podcast_id)"
                  >Edit</CButton
                  >
                </div>
              </td>
            </template>
          </CDataTable>
          <div class="pagination-nav">
            <div
                class="pagination-btn-refresh"
                @click="getCorporatePodcastList('REFRESH')"
            >
              Refresh
            </div>
            <div
                class="pagination-btn-back"
                @click="getCorporatePodcastList('BACK')"
            >
              back
            </div>
            <div class="pagination-page-title">{{ request.page }}</div>
            <div
                class="pagination-btn-next"
                @click="getCorporatePodcastList('NEXT')"
            >
              next
            </div>
          </div>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import jwt from "jsonwebtoken";
import CorporatePodcastListUseCase from "./app/usecase";

export default {
  name: "corporate-podcast",
  data() {
    return {
      items: [],
      fields: [
        { key: "corporate_podcast_id", label: "ID" },
        { key: "corporate_podcast_title", label: "Name" },
        { key: "status", label: "Status" },
        { key: "corporate_podcast_ids", label: "Action" },
      ],
      token: "Bearer " + localStorage.getItem("token"),
      request: {
        page: 1,
        per_page: 20,
        q: "",
        display_page: "",
        s: "",
      },
      debounce: {
        timeout: 0,
        duration: 500,
      },
      searchTimeout: null,
    };
  },
  mounted() {
    this.authentication();
    this.getCorporatePodcastList();
  },
  methods: {
    authentication() {
      const data = jwt.decode(localStorage.getItem("token"));
      if (
          data.account_group === "MARKETING" ||
          data.account_group === "ADMIN" ||
          data.account_group === "ADMINISTRATOR" ||
          data.account_group === "EXTERNAL"
      ) {
        return null;
      } else {
        this.$router.push({ path: `/` });
      }
    },
    onSearch() {
      clearTimeout(this.searchTimeout)
      this.searchTimeout = setTimeout(this.searchCorporatePodcastList, this.debounce.duration);
    },
    async searchCorporatePodcastList() {
      try {
        await this.getCorporatePodcastList()
        this.request.page = 1
      } catch (err) {
        await this.$swal.fire({
          icon: "error",
          text: err
        })
      }
    },
    async getCorporatePodcastList(action) {
      try {
        this.validatePagination(action);
        const queries = Object.keys(this.request).map((key) => key + "=" + this.request[key]).join("&");
        const { data, err } = await CorporatePodcastListUseCase.getAll(queries);
        if (err || !data || data.length == 0) {
          this.validateNextPagination(action);
          this.err = err;
        } else {
          window.scrollTo(0, 0);
          this.items = data.map((obj) => {
            return {
              ...obj,
              status: this.mapStatus(obj.status),
            };
          });
        }
      } catch (err) {
        await this.$swal.fire({
          icon: "error",
          text: err,
        });
      }
    },
    mapStatus(status) {
      if (status === "ACTIVE") return "Active";
      if (status === "INACTIVE") return "Inactive";
      return status;
    },
    validatePagination(action) {
      if (action === "NEXT") {
        this.request.page = this.request.page + 1;
      } else if (action === "BACK") {
        if (this.request.page > 1) {
          this.request.page = this.request.page - 1;
        }
      } else if (action === "REFRESH") {
        this.request.page = 1;
      } else {
        this.request.page = 1;
      }
    },
    validateNextPagination(action) {
      if (action === "NEXT") {
        this.request.page = this.request.page - 1;
      } else {
        this.items = [];
      }
    },
    rowClicked(item) {
      this.$router.push({ path: `/management/corporate-podcast/${item}` });
    },
    pageChange(val) {
      this.$router.push({ query: { page: val } });
    },
    corporatePodcastCreate() {
      this.$router.push({ path: `/management/corporate-podcast/create` });
    },
  },
};
</script>

<style scoped>
@import url("./CorporatePodcast.css");
</style>
